import React, { useState, useEffect} from 'react';
import { logConsent } from '../services/telemetry';
import { getOrCreateUserId } from '../utils/userId';

import './Menu.css';
import { FaCartPlus, FaTimes, FaShoppingCart , FaTrashAlt} from 'react-icons/fa'
import carpsal from '../images/carpaccio-salmone.jpg';
import carpton from '../images/carpaccio-tonno.jpg';
import carpmist from '../images/carpaccio-misto.jpg';
import wisake from '../images/wind-sake.jpg';
import wimis from '../images/wind-misto.jpg';
import burmaz from '../images/burrata-mazzara.jpg';
import carbur from '../images/carpaccio-burrata.jpg';
import carduo from '../images/carpaccio-duomila.jpg';

import tarsak from '../images/tartare-sake.jpg';
import tarton from '../images/tartare-tonno.jpg';
import tarduo from '../images/tartare-duomila.jpg';
import tarama from '../images/tartare-amaebi.jpg';
import nidosak from '../images/nido-sake.jpg';
import nidotun from '../images/nido-tuna.jpg';
import millsake from '../images/millefoglie-sake.jpg';
import milltun from '../images/millefoglie-tuna.jpg';
import chiduo from '../images/chips-duomila.jpg';
import chitu from '../images/chips-tuna.jpg';
import blacksa from '../images/black-sake.jpg';
import blacktu from '../images/black-tuna.jpg';
import tacvege from '../images/tacos-vegeta.jpg';
import tacsak from '../images/tacos-sake.jpg';
import tactu from '../images/tacos-tuna.jpg';
import duofash from '../images/duomila-fashion.jpg';
import cevich from '../images/ceviche.jpg';
import sashiflam from '../images/sashimi-flambe.jpg';
import invrucc from '../images/involtini-rucola.jpg';
import sakeflo from '../images/sake-flo.jpg';
import specflo from '../images/speciale-flowers.jpg';
import nigsake from '../images/nigiri-sake.jpg';
import nigmag from '../images/nigiri-maguro.jpg';
import nigsuz from '../images/nigiri-suzuki.jpg';
import nigebi from '../images/nigiri-ebi.jpg';
import nigavo from '../images/nigiri-avocado.jpg';
import giosakfla from '../images/gio-sake-flambe.jpg';
import giomagufla from '../images/gio-maguro-flambe.jpg';
import giosuzfla from '../images/gio-suzuki-flambe.jpg';
import gioebi from '../images/gio-ebi.jpg';
import blacksa4 from '../images/black-sake-4.jpg';
import smal from '../images/small.jpg';
import sushduo from '../images/sushi-duomila.jpg';
import sassake from '../images/sashimi-sake.jpg';
import samag from '../images/sashimi-maguro.jpg';
import sasmis from '../images/sashimi-misto.jpg';
import hossak from '../images/hoso-shake.jpg';
import hosmag from '../images/hoso-maguro.jpg';
import hossuz from '../images/hoso-suzuki.jpg';
import hosebi from '../images/hoso-ebi.jpg';
import hosoveg from '../images/hoso-vegeta.jpg';
import hoscet from '../images/hoso-cetrioli.jpg';
import urasakavo from '../images/uramaki-sake-avocado.jpg';
import uratonavo from '../images/uramaki-tonno-avocado.jpg';
import uraphila from '../images/uramaki-philadelphia.jpg';
import uraebit from '../images/uramaki-ebiten.jpg';
import uracali from '../images/uramaki-california.jpg';
import miurroll from '../images/miura-roll.jpg';
import mexroll from '../images/mexican-roll.jpg';
import uratuncot from '../images/uramaki-tuna-cotto.jpg';
import urachick from '../images/uramaki-chicken.jpg';
import urapatswe from '../images/uramaki-patate-sweet.jpg';
import uraebi from '../images/uramaki-ebi.jpg';
import uratunspi from '../images/uramaki-tuna-spicy.jpg';
import dragroll from '../images/drago-roll.jpg';
import urapist from '../images/uramaki-pistacchio.jpg';
import uralemon from '../images/uramaki-lemon.jpg';
import urasakcot from '../images/uramaki-sake-cotto.jpg';
import uramand from '../images/uramaki-mandorle.jpg';
import uratigroll from '../images/uramaki-tiger-roll.jpg';
import venroll from '../images/venere-roll.jpg';
import duoroll from '../images/duomila-roll.jpg';
import uranewmiu from '../images/ura-new-miura.jpg';
import nachroll from '../images/nachos-roll.jpg';
import exoroll from '../images/exotic-roll.jpg';
import tarroll from '../images/tartufo-roll.jpg';
import ciocc from '../images/cioccolato.jpg';
import winder from '../images/winder.jpg';
import rokro from '../images/rokro.jpg';
import mazzar from '../images/mazzara.jpg';
import blackman from '../images/black-mandorle.jpg';
import blackpist from '../images/black-pistacchio.jpg';
import lovepist from '../images/love-pistacchio.jpg';
import lovedrag from '../images/love-drago.jpg';
import lovemaz from '../images/love-mazzara.jpg';
import hosfrifra from '../images/hoso-fritto-fragola.jpg';
import hosfriphila from '../images/hoso-fritto-phila.jpg';
import hosfrit from '../images/hoso-fritto.jpg';
import katrol from '../images/kataifi-roll.jpg';
import katduo from '../images/kataifi-duomila.jpg';
import futfrit from '../images/futo-fritto.jpg';
import urafrit from '../images/ura-fritto.jpg';
import susbox1 from '../images/sushi-box-1.jpg';
import susbox2 from '../images/sushi-box-2.jpg';
import newgun from '../images/new-gunkan.jpg';
import gunspisak from '../images/gunkan-spicy-sake.jpg';
import gunspiton from '../images/gunkan-spicy-tonno.jpg';
import gunmis from '../images/gunkan-miso.jpg';
import gunphila from '../images/gunkan-philadelphia.jpg';
import chirasha from '../images/chirashi-shake.jpg';
import chiramis from '../images/chirashi-misto.jpg';
import frutmarass from '../images/frutti-di-mare.jpg';
import wak from '../images/wakame.jpg';
import edama from '../images/edamame.jpg';
import panbianc from '../images/pane-bianco.jpg';
import pancon from '../images/pane-coniglio.jpg';
import ravvap from '../images/ravioli-vapore.jpg';
import shaomai from '../images/shaomai.jpg';
import ravverd from '../images/ravioli-verdure.jpg';
import ravgamb from '../images/ravioli-gamberi.jpg';
import ravpiast from '../images/ravioli-piastra.jpg';
import nuvgamb from '../images/nuvole-di-gamberi.jpg';
import invprim from '../images/involtini-primavera.jpg';
import invgam from '../images/involtini-gambero.jpg';
import shrpot from '../images/shrimps-potato.jpg';
import patat from '../images/patatine.jpg';
import patsmil from '../images/patate-smile.jpg';
import pollcoto from '../images/pollo-cotoletta.jpg';
import chelgran from '../images/chele-di-granchio.jpg';
import polptako from '../images/polpetta-takoyaki.jpg';
import ebitem from '../images/ebi-tempura.jpg';
import tempmari from '../images/tempura-mariawase.jpg';
import zupmis from '../images/zuppa-miso.jpg';
import zupagro from '../images/zuppa-agropiccante.jpg';
import zuppolmai from '../images/zuppa-di-pollo-e-mais.jpg';
import riscan from '../images/riso-cantonese.jpg';
import risgam from '../images/riso-gambero.jpg';
import riscur from '../images/riso-curry.jpg';
import risspec from '../images/riso-speciale.jpg';
import gyuram from '../images/gyuniku-ramen.jpg';
import spaverd from '../images/spaghetti-verdure.jpg';
import spagamb from '../images/spaghetti-gamberi.jpg';
import spasoverd from '../images/spaghetti-soia-verdure.jpg';
import spasogamb from '../images/spaghetti-soia-gamberi.jpg';
import spasocar from '../images/spaghetti-soia-carne.jpg';
import spayaud from '../images/spaghetti-yaki-udon.jpg';
import sparamsal from '../images/spaghetti-ramen-saltato.jpg';
import spariscur from '../images/spaghetti-riso-curry.jpg';
import spapadthai from '../images/spaghetti-pad-thai.jpg';
import pollimo from '../images/pollo-limone.jpg';
import polfunbam from '../images/pollo-funghi-bambu.jpg';
import polcury from '../images/pollo-curry.jpg';
import polmand from '../images/pollo-mandorle.jpg';
import polkung from '../images/pollo-kungpao.jpg';
import maialagro from '../images/maiale-agrodolce.jpg';
import manzpat from '../images/manzo-patate.jpg';
import manzpep from '../images/manzo-peperoni.jpg';
import manfungbamb from '../images/manzo-funghi-bambu.jpg';
import anaarar from '../images/anatra-arrosto-aromi.jpg';
import anaaranc from '../images/anatra-arancia.jpg';
import gambsalagro from '../images/gamberi-salsa-agrodolce.jpg';
import gambfunbamb from '../images/gamberi-funghi-bambu.jpg';
import gambpicc from '../images/gamberi-piccante.jpg';
import gambsalpep from '../images/gamberi-sale-pepe.jpg';
import padfrutmar from '../images/padella-frutti-mare.jpg';
import padmanz from '../images/padella-manzo.jpg';
import padverd from '../images/padella-verdure.jpg';
import spiedgam from '../images/spiedini-gambero.jpg';
import spiedpol from '../images/spiedini-pollo.jpg';
import scamppias from '../images/scampi-alla-piastra.jpg';
import gambpias from '../images/gamberi-alla-piastra.jpg';
import salmpias from '../images/salmone-piastra.jpg';
import zucpias from '../images/zucchine-alla-piastra.jpg';
import pepmist from '../images/peperoni-misto.jpg';
import tatsal from '../images/tataki-salmone.jpg';
import sparisver from '../images/spaghetti-riso-verdure.jpg';
import sparisgamb from '../images/spaghetti-riso-gamberi.jpg';
import logoImage from '../images/logo.png';

import manzotart from '../images/manzo-tartar.jpg';
import pancres from '../images/pan-cress.jpg';
import amaebitar from '../images/amaebi-tartar.jpg';
import cevicspecial from '../images/ceviche-special.jpg';
import manznig from '../images/manzo-nigiri.jpg';
import guntemebi from '../images/gunkan-tempura-ebi.jpg';
import gunfusio from '../images/gunkan-fusion.jpg';
import gunavo from '../images/gunkan-avocado.jpg';
import ebitemspe from '../images/ebi-tempura-special.jpg';
import ebipanspe from '../images/ebi-pan-special.jpg';
import spagragu from '../images/spaghetti-ragu.jpg';
import spagscog from '../images/spaghetti-scoglio.jpg';
import cremchick from '../images/crem-chicken.jpg';

import introImage1 from '../images/logo1.png';
import introImage2 from '../images/Order-ahead-bro.png';
import introImage3 from '../images/eating-sushi-bro.png';

const menuItems = [
  { id: 1, name: 'Carpaccio Salmone 5pz', description: 'Salmone, salsa ponzu, masago, olio verde', price: 8.00, allergens: ['Pesce', 'Soia'] , image: carpsal , category: "Carpaccio"},
  { id: 2, name: 'Carpaccio Tonno 5pz', description: 'Tonno, salsa ponzu, masago, olio verde', price: 9.00, allergens: ['Pesce', 'Soia'] , image: carpton , category: "Carpaccio"},
  { id: 3, name: 'Carpaccio Misto 5pz', description: 'Salmone, tonno, branzino, salsa ponzu, masago, olio verde', price: 9.00, allergens: ['Pesce', 'Soia'] , image: carpmist , category: "Carpaccio"},
  { id: 4, name: 'Wind Sake 5pz', description: 'Salmone, salsa frutta passione, crema avocado, olio verde, salsa burrata', price: 10.00, allergens: ['Pesce', 'Latte'] , image: wisake, category: "Carpaccio"},
  { id: 5, name: 'Wind Misto 5pz', description: 'Pesce misto, olio verde, salsa mango, pistacchio', price: 10.00, allergens: ['Pesce', 'Noci'] , image: wimis, category: "Carpaccio"},
  { id: 6, name: 'Burrata Mazzara', description: 'Mazzara*, salsa burrata, olio verde, paprika, prezzemolo', price: 10.00, allergens: ['Crostacei', 'Latte'] , image: burmaz, category: "Carpaccio"},
  { id: 12, name: 'Carpaccio Burrata 5pz', description: 'Pesce misto, mazzara*, salsa burrata, cioccolato, paprika, prezzemolo', price: 14.00, allergens: ['Pesce', 'Crostacei','Latte'] , image: carbur, category: "Carpaccio"},
  { id: 13, name: 'Carpaccio Duomila 5pz', description: 'Pesce misto, metà salsa burrata, metà salsa passione, crema avocado, pepe piccante dolce, capperi', price: 14.00, allergens: ['Pesce', 'Latte'], image: carduo , category: "Carpaccio"},
  
  
  
  { id: 18, name: 'Tartare Sake', description: 'Salmone, salsa ponzu, crema avocado, olio verde', price: 10.00, allergens: ['Pesce','Soia']  , category: "Tartare",image: tarsak},
  { id: 19, name: 'Tartare Tonno', description: 'Tonno, salsa ponzu, crema avocado, olio verde', price: 11.00, allergens: ['Pesce','Soia']  , category: "Tartare",image: tarton},
  { id: 20, name: 'Manzo Tartar', description: 'Sale, pepe, olio, salsa tartufo e cuconci', price: 12.00, allergens: []  , category: "Tartare",image: manzotart},
  { id: 21, name: 'Pan Cress', description: 'Croccantini manzo, pomodoro e olio crema tarta', price: 12.00, allergens: []  , category: "Tartare",image: pancres},
  { id: 22, name: 'Amaebi Tartar', description: 'Mango, avocado, papaya, tobiko e farina di tempura', price: 12.00, allergens: ['Glutine','Pesce','Soia']  , category: "Tartare",image: amaebitar},

  { id: 25, name: 'Tartare Duomila', description: 'Pesce misto, crema avocado, gambero* crudo, tobiko*', price: 12.00, allergens: ['Pesce', 'Crostacei']  , category: "Tartare",image: tarduo},
  { id: 26, name: 'Tartare Amaebi', description: 'Gambero* crudo, pomodoro, avocado, salsa ponzu, olio verde', price: 10.00, allergens: ['Crostacei','Soia']  , category: "Tartare",image: tarama},
  
  
  
  { id: 30, name: 'Nido Sake', description: 'Involtini nocci, spicy salmone, pistacchio, salsa rucola oro', price: 6.00, allergens: ['Glutine','Pesce', 'Noci']  , category: "Nido",image: nidosak},
  { id: 31, name: 'Nido Tuna', description: 'Involtini nocci, spicy tonno, masago, salsa zafferano oro', price: 7.00, allergens: ['Glutine','Pesce', 'Noci']  , category: "Nido",image: nidotun},
  
  
  { id: 37, name: 'Millefoglie Sake', description: 'Pasta fritta, salmone spicy, salsa mango, pistacchio', price: 7.00, allergens: ['Glutine','Pesce', 'Noci']  , category: "Millefoglie",image: millsake},
  { id: 38, name: 'Millefoglie Tuna', description: 'Pasta fritta, tuna spicy, pistacchio, philadelphia, salsa mango', price: 8.00, allergens: ['Glutine','Pesce', 'Noci', 'Latte']  , category: "Millefoglie",image: milltun},
  { id: 39, name: 'Chips Duomila', description: 'Chips, salmone spicy, mango, maionese', price: 5.50, allergens: ['Glutine','Pesce', 'Uova']  , category: "Millefoglie",image: chiduo},
  { id: 40, name: 'Chips Tuna', description: 'Chips, tonno, mango, maionese', price: 6.00, allergens: ['Glutine','Pesce', 'Uova']  , category: "Millefoglie",image: chitu},
  { id: 41, name: 'Black Sake', description: 'Alghe fritto, philadelphia, spicy salmone, salsa tartufo, salsa rucola', price: 6.00, allergens: ['Pesce', 'Latte']  , category: "Millefoglie",image: blacksa},
  { id: 42, name: 'Black Tuna', description: 'Alghe fritto, spicy tonno, salsa zafferano, salsa tartufo', price: 6.50, allergens: ['Pesce']  , category: "Millefoglie",image: blacktu},
  
  
  { id: 46, name: 'Tacos Vegeta', description: 'Tartare avocado, mango, salsa rucola, tobiko', price: 5.00, allergens: ['Glutine','Pesce']  , category: "Tacos",image: tacvege},
  { id: 47, name: 'Tacos Sake', description: 'Salmone, salsa avocado, salsa tartufo, philadelphia', price: 8.00, allergens: ['Glutine','Pesce', 'Latte']  , category: "Tacos",image: tacsak},
  { id: 48, name: 'Tacos Tuna', description: 'Tonno, philadelphia, salsa zafferano, salsa tartufo', price: 8.50, allergens: ['Glutine','Pesce', 'Latte']  , category: "Tacos",image: tactu},
  
  
  { id: 53, name: 'Duomila Fashion', description: 'Gamberi* fritti, philadelphia, salmone, kataifi, salsa teriyaki', price: 6.00, allergens: ['Glutine','Crostacei', 'Latte', 'Pesce','Soia']  , category: "Flowers",image: duofash},
  { id: 54, name: 'Ceviche', description: 'Salmone, tonno, branzino, mango, avocado, salsa passione', price: 10.00, allergens: ['Pesce']  , category: "Flowers",image: cevich},
  { id: 55, name: 'Sashimi Flambè', description: 'Salmone scottato, salsa mango, olio verde, pistacchio, decorazione salsa rucola', price: 8.50, allergens: ['Pesce', 'Noci']  , category: "Flowers",image: sashiflam},
  { id: 56, name: 'Ceviche Special', description: 'Gambero fritto, salmone, papaya, mozzarella, tartufo e seme di chia', price: 10.00, allergens: ['Glutine','Crostacei','Latte','Pesce']  , category: "Flowers",image: cevicspecial},

  { id: 58, name: 'Involtini Rucola', description: 'Involtini salmone ripieno arancia e mango, salsa ponzu', price: 6.00, allergens: ['Pesce','Soia']  , category: "Flowers",image: invrucc},
  { id: 59, name: 'Sake Flo', description: 'Involtini di salmone scottato ripieno di verdure in tempura, con salsa miso e pistacchio esterno', price: 6.00, allergens: ['Pesce','Glutine', 'Soia', 'Noci']  , category: "Flowers",image: sakeflo},
  { id: 60, name: 'Speciale Flowers', description: 'Fiore zucca, philadelphia, gambero* crudo, tartufo', price: 7.00, allergens: ['Glutine','Latte', 'Crostacei']  , category: "Flowers",image: specflo},
  
  
  { id: 64, name: 'Nigiri Sake', description: 'Salmone', price: 3.50, allergens: ['Pesce']  , category: "Nigiri",image: nigsake},
  { id: 65, name: 'Nigiri Maguro', description: 'Tonno', price: 4.00, allergens: ['Pesce']  , category: "Nigiri",image: nigmag},
  { id: 66, name: 'Nigiri Suzuki', description: 'Branzino', price: 3.50, allergens: ['Pesce']  , category: "Nigiri",image: nigsuz},
  { id: 67, name: 'Nigiri Ebi', description: 'Gambero* cotto', price: 4.00, allergens: ['Crostacei']  , category: "Nigiri",image: nigebi},
  { id: 68, name: 'Manzo Nigiri', description: 'Manzo scottato, tartufo, cipollina e salsa yakkyniku', price: 6.00, allergens: []  , category: "Nigiri",image: manznig},
  { id: 69, name: 'Nigiri Avocado', description: 'Avocado', price: 3.50, allergens: []  , category: "Nigiri",image: nigavo},
  { id: 72, name: 'Gio Sake Flambè 2pz', description: 'Salmone scottato, salsa miso, tobiko*', price: 4.00, allergens: ['Pesce', 'Soia']  , category: "Nigiri",image: giosakfla},
  { id: 73, name: 'Gio Maguro Flambè 2pz', description: 'Tonno scottato, salsa zafferano, pistacchio', price: 4.50, allergens: ['Pesce', 'Noci']  , category: "Nigiri",image: giomagufla},
  { id: 74, name: 'Gio Suzuki Flambè 2pz', description: 'Branzino scottato, salsa maio, cipolla fritta', price: 4.00, allergens: ['Pesce', 'Uova', 'Glutine']  , category: "Nigiri",image: giosuzfla},
  { id: 75, name: 'Gio Ebi 2pz', description: 'Gambero* cotto, salsa tartufo two, kataifi', price: 4.00, allergens: ['Crostacei']  , category: "Nigiri",image: gioebi},
  { id: 77, name: 'Black Sake 4pz', description: 'Riso venere, salmone scottato, salsa tartufo two, pistacchio', price: 8.00, allergens: ['Pesce','Noci']  , category: "Nigiri",image: blacksa4},
  { id: 80, name: 'Small', description: 'Nigiri mix 4pz, uramaki 2pz', price: 9.00, allergens: ['Pesce','Crostacei','Sesamo']  , category: "Nigiri",image: smal},
  { id: 81, name: 'Sushi Duomila', description: 'Nigiri misto 5pz, uramaki 2pz, gunkan 1pz', price: 13.00, allergens: ['Pesce','Crostacei','Sesamo']  , category: "Nigiri",image: sushduo},
  
  
  { id: 84, name: 'Sashimi Sake 4pz', description: 'Salmone', price: 6.00, allergens: ['Pesce']  , category: "Sashimi",image: sassake},
  { id: 85, name: 'Sashimi Maguro 4pz', description: 'Tonno', price: 7.00, allergens: ['Pesce']  , category: "Sashimi",image: samag},
  { id: 86, name: 'Sashimi Misto 6pz', description: 'Salmone 3pz, tonno 2pz, branzino 1pz', price: 8.00, allergens: ['Pesce']  , category: "Sashimi",image: sasmis},
  
  
  { id: 90, name: 'Hoso Shake', description: 'Salmone', price: 4.00, allergens: ['Pesce'] , category: "Hosomaki",image: hossak},
  { id: 91, name: 'Hoso Maguro', description: 'Tonno', price: 4.50, allergens: ['Pesce'] , category: "Hosomaki",image: hosmag},
  { id: 92, name: 'Hoso Suzuki', description: 'Branzino', price: 4.00, allergens: ['Pesce'] , category: "Hosomaki",image: hossuz},
  { id: 93, name: 'Hoso Ebi', description: 'Gambero* cotto', price: 4.00, allergens: ['Crostacei'] , category: "Hosomaki",image: hosebi},
  { id: 94, name: 'Hoso Vegeta', description: 'Avocado', price: 4.00, allergens: [] , category: "Hosomaki",image: hosoveg},
  { id: 95, name: 'Hoso Cetrioli', description: 'Cetrioli', price: 4.00, allergens: [] , category: "Hosomaki",image: hoscet},
  
  
  { id: 100, name: 'Uramaki Sake Avocado', description: 'Salmone, avocado, esterno sesamo', price: 5.00, allergens: ['Pesce', 'Sesamo'] , category: "Uramaki",image: urasakavo},
  { id: 101, name: 'Uramaki Tonno Avocado', description: 'Tonno, avocado, esterno sesamo', price: 5.00, allergens: ['Pesce', 'Sesamo'] , category: "Uramaki",image: uratonavo},
  { id: 102, name: 'Uramaki Philadelphia', description: 'Salmone, avocado, esterno sesamo, philadelphia', price: 5.50, allergens: ['Latte', 'Pesce', 'Sesamo'] , category: "Uramaki",image: uraphila},
  { id: 103, name: 'Uramaki EbiTen', description: 'Gambero* tempura, philadelphia, esterno sesamo, kataifi, salsa teriyaki', price: 5.50, allergens: ['Glutine','Crostacei', 'Latte', 'Sesamo', 'Soia'] , category: "Uramaki",image: uraebit},
  { id: 104, name: 'Uramaki California', description: 'Surimi*, avocado, esterno sesamo, maionese', price: 5.00, allergens: ['Crostacei', 'Uova', 'Sesamo'] , category: "Uramaki",image: uracali},
  { id: 106, name: 'Miura Roll', description: 'Salmone cotto e cetriolo, esterno salmone scottato, kataifi, salsa rucola', price: 6.00, allergens: ['Pesce', 'Glutine', 'Sesamo'] , category: "Uramaki",image: miurroll},
  { id: 107, name: 'Mexican Roll', description: 'Gambero* tempura, philadelphia, esterno maionese spicy, nachos', price: 6.00, allergens: ['Glutine','Crostacei', 'Latte', 'Sesamo', 'Uova'] , category: "Uramaki",image: mexroll},
  { id: 108, name: 'Uramaki Tuna Cotto', description: 'Tonno cotto, cetriolo esterno sesamo, philadelphia, rucola fritta, salsa teriyaki', price: 5.50, allergens: ['Pesce', 'Sesamo', 'Latte', 'Soia'] , category: "Uramaki",image: uratuncot},
  { id: 109, name: 'Uramaki Chicken', description: 'Pollo fritto, esterno salsa piccante e salsa teriyaki e cipolla fritta', price: 5.00, allergens: ['Glutine', 'Sesamo', 'Soia'] , category: "Uramaki",image: urachick},
  { id: 110, name: 'Uramaki Patate Sweet', description: 'Patate dolce fritto, esterno sesamo, salsa teriyaki, cipolla fritta', price: 5.00, allergens: ['Glutine', 'Sesamo', 'Soia'] , category: "Uramaki",image: urapatswe},
  { id: 111, name: 'Uramaki Ebi', description: 'Gambero* cotto, avocado, philadelphia esterno sesamo', price: 5.00, allergens: ['Crostacei', 'Latte', 'Sesamo'] , category: "Uramaki",image: uraebi},
  { id: 113, name: 'Uramaki Tuna Spicy', description: 'Tonno spicy, cetriolo, sopra tonno spicy e maio spicy, masago', price: 5.50, allergens: ['Pesce', 'Uova','Sesamo'] , category: "Uramaki",image: uratunspi},
  { id: 114, name: 'Drago Roll', description: 'Tempura gambero* e philadelphia, avocado, sesamo, salsa teriyaki, cipolla fritta', price: 5.50, allergens: ['Glutine','Crostacei', 'Latte', 'Sesamo', 'Soia'], category: "Uramaki" ,image: dragroll},
  { id: 115, name: 'Uramaki Pistacchio', description: 'Salmone, avocado, esterno di salmone scottato, maionese dolce, pistacchio, salsa teriyaki', price: 6.50, allergens: ['Pesce','Uova','Sesamo', 'Noci','Soia'] , category: "Uramaki",image: urapist},
  { id: 116, name: 'Uramaki Lemon', description: 'Salmone, avocado, esterno salmone, lemon, maionese, tobiko*, teriyaki', price: 6.50, allergens: ['Pesce', 'Uova','Sesamo', 'Soia'] , category: "Uramaki",image: uralemon},
  { id: 117, name: 'Uramaki Sake Cotto', description: 'Salmone cotto, esterno salmone scottato, salsa teriyaki', price: 6.00, allergens: ['Pesce','Sesamo', 'Soia'] , category: "Uramaki",image: urasakcot},
  { id: 118, name: 'Uramaki Mandorle', description: 'Salmone cotto, philadelphia, esterno salmone scottato, maionese piccante, mandorle', price: 6.00, allergens: ['Pesce', 'Latte','Uova', 'Noci', 'Sesamo'] , category: "Uramaki",image: uramand},
  { id: 119, name: 'Uramaki Tiger Roll', description: 'Gamberi* in tempura, esterno salmone scottato, salsa teriyaki, maionese piccante, farina di tempura', price: 6.00, allergens: ['Glutine','Crostacei','Pesce','Soia', 'Uova', 'Sesamo' ] , category: "Uramaki",image: uratigroll},
  { id: 122, name: 'Venere Roll', description: 'Riso venere, gambero* tempura, philadelphia esterno salmone, pistacchio, salsa teriyaki', price: 6.50, allergens: ['Glutine','Crostacei', 'Latte','Pesce', 'Noci','Sesamo', 'Soia'] , category: "Uramaki",image: venroll},
  { id: 123, name: 'Duomila Roll', description: 'Riso venere, gambero* tempura, philadelphia esterno salmone spicy, mandorle, salsa teriyaki', price: 6.50, allergens: ['Glutine','Crostacei', 'Latte','Pesce', 'Noci','Sesamo', 'Soia'] , category: "Uramaki",image: duoroll},
  { id: 124, name: 'Ura New Miura', description: 'Salmone cotto, philadelphia esterno salmone crudo, salsa teriyaki, cipolla fritta', price: 6.50, allergens: ['Latte','Pesce', 'Glutine', 'Soia', 'Sesamo'] , category: "Uramaki",image: uranewmiu},
  { id: 125, name: 'Nachos Roll', description: 'Riso venere, salmone spicy esterno maionese piccante, nachos', price: 6.50, allergens: ['Pesce','Uova', 'Glutine', 'Sesamo' ] , category: "Uramaki",image: nachroll},
  
  
  { id: 131, name: 'Exotic Roll', description: 'Mango, salmone, esterno salmone, kiwi, salsa mango', price: 8.00, allergens: ['Pesce','Sesamo'] , category: "Duomila Speciale",image: exoroll},
  { id: 132, name: 'Tartufo Roll', description: 'Cetriolo, avocado, esterno salmone, gambero* crudo, tartufo, salsa teriyaki', price: 8.00, allergens: ['Pesce', 'Crostacei','Sesamo', 'Soia'] , category: "Duomila Speciale",image: tarroll},
  { id: 133, name: 'Cioccolato', description: 'Tempura verdure mix, philadelphia, esterno salmone scottato, cioccolato', price: 8.00, allergens: ['Glutine', 'Latte', 'Pesce', 'Sesamo'] , category: "Duomila Speciale",image: ciocc},
  { id: 134, name: 'Winder', description: 'Tempura gamberi*, philadelphia, masago, salsa teriyaki', price: 7.00, allergens: ['Glutine','Crostacei', 'Latte','Sesamo', 'Soia'] , category: "Duomila Speciale",image: winder},
  { id: 135, name: 'Rokro', description: 'Avocado, philadelphia, esterno salmone spicy salsa rucola mandorle', price: 8.00, allergens: ['Pesce', 'Latte', 'Noci', 'Sesamo'] , category: "Duomila Speciale",image: rokro},
  { id: 138, name: 'Mazzara', description: 'Tempura gamberi*, esterno philadelphia, avocado, gambero* crudo, salsa passione', price: 9.00, allergens: ['Glutine','Crostacei', 'Latte', 'Sesamo'], category: "Duomila Speciale" ,image: mazzar},
  { id: 139, name: 'Black Mandorle', description: 'Avocado, philadelphia, esterno tartare salmone, mandorle, salsa rucola', price: 7.00, allergens: ['Pesce', 'Latte', 'Noci','Sesamo'], category: "Duomila Speciale" ,image: blackman},
  { id: 140, name: 'Black Pistacchio', description: 'Salmone spicy, cetriolo, esterno salmone scottato, salsa miso, pistacchio', price: 7.00, allergens: ['Pesce', 'Noci','Sesamo', 'Soia'] , category: "Duomila Speciale",image: blackpist},
  { id: 141, name: 'Love Pistacchio', description: 'Salmone spicy, cetrioli, esterno salmone scottato, salsa miso, pistacchio', price: 7.00, allergens: ['Pesce', 'Noci','Sesamo', 'Soia'] , category: "Duomila Speciale",image: lovepist},
  { id: 142, name: 'Love Drago', description: 'Tempura gamberi*, esterno avocado, cipolla, salsa teriyaki', price: 7.00, allergens: ['Glutine','Crostacei','Sesamo', 'Soia'] , category: "Duomila Speciale",image: lovedrag},
  { id: 143, name: 'Love Mazzara', description: 'Avocado, philadelphia, sesamo nero, mazzara*, salsa rucola, masago', price: 10.00, allergens: ['Crostacei', 'Latte', 'Sesamo'] , category: "Duomila Speciale",image: lovemaz},
  
  
  { id: 146, name: 'Hoso Fritto Fragola 4pz', description: 'Salmone, esterno philadelphia, fragola, salsa teriyaki', price: 5.00, allergens: ['Glutine', 'Latte', 'Soia','Pesce'], category: "Maki Fritti",image: hosfrifra },
  { id: 147, name: 'Hoso Fritto Phila 4pz', description: 'Salmone, esterno philadelphia, salsa avocado, salsa teriyaki, fragola', price: 5.00, allergens: ['Glutine', 'Latte', 'Soia','Pesce'] , category: "Maki Fritti",image: hosfriphila},
  { id: 148, name: 'Hoso Fritto 4pz', description: 'Salmone, esterno salmone spicy, salsa teriyaki, kataifi', price: 5.00, allergens: ['Pesce', 'Glutine','Soia'] , category: "Maki Fritti",image: hosfrit},
  { id: 149, name: 'Kataifi Roll 3pz', description: 'Surimi*, esterno salmone spicy, salsa teriyaki', price: 4.50, allergens:  ['Pesce', 'Glutine','Soia','Crostacei'], category: "Maki Fritti",image: katrol },
  { id: 150, name: 'Kataifi Duomila 3pz', description: 'Surimi*, esterno Pesce mix, salsa carote', price: 5.00, allergens: ['Pesce', 'Glutine','Crostacei'] , category: "Maki Fritti",image: katduo},
  { id: 151, name: 'Futo Fritto 3pz', description: 'Pesce mix, avocado, salsa teriyaki', price: 6.00, allergens: ['Pesce', 'Glutine','Soia']  , category: "Maki Fritti",image: futfrit},
  { id: 152, name: 'Ura Fritto 4pz', description: 'Salmone, avocado, sopra philadelphia, salsa teriyaki', price: 5.50, allergens: ['Glutine', 'Latte', 'Soia','Pesce','Sesamo'], category: "Maki Fritti",image: urafrit },
  
  
  { id: 154, name: 'Sushi Box 1', description: '24pz uramaki, 12pz hosomaki, 6pz sashimi misto, 5pz sushi, 5pz gunkan', price: 48.00, allergens: ['Glutine', 'Latte', 'Crostacei','Pesce','Sesamo'], category: "Sushi Box" ,image: susbox1},
  { id: 155, name: 'Sushi Box 2', description: '4pz uramaki, 5pz sushi, 6pz hosomaki, 2pz gunkan', price: 18.00, allergens: ['Latte', 'Soia','Pesce','Sesamo'], category: "Sushi Box" ,image: susbox2},
  
  
  { id: 158, name: 'New Gunkan', description: 'Salmone scottato, salsa tartufo two, pistacchio', price: 5.00, allergens: ['Pesce', 'Noci'] , category: "Gunkan",image: newgun},
  { id: 162, name: 'Gunkan Spicy Sake', description: 'Salmone, salmone spicy', price: 5.00, allergens: ['Pesce'] , category: "Gunkan",image: gunspisak},
  { id: 163, name: 'Gunkan Spicy Tonno', description: 'Tonno, tonno spicy', price: 5.00, allergens: ['Pesce'] , category: "Gunkan",image: gunspiton},
  { id: 165, name: 'Gunkan Miso', description: 'Salmone scottato, salsa miso, tobiko*, farina tempura', price: 5.00, allergens: ['Glutine','Pesce','Soia'] , category: "Gunkan",image: gunmis},
  { id: 166, name: 'Gunkan Philadelphia', description: 'Salmone, philadelphia, masago', price: 5.00, allergens: ['Pesce', 'Latte'], category: "Gunkan",image: gunphila },
  { id: 167, name: 'Gunkan Tempura Ebi', description: 'Philadelphia, gambero fritto e salsa teriyaki', price: 5.00, allergens: ['Glutine', 'Crostacei','Latte','Soia'], category: "Gunkan",image: guntemebi },
  { id: 168, name: 'Gunkan Fusion', description: 'Philadelphia, pomodoro sott\'olio e salsa teriyaki', price: 5.00, allergens: ['Pesce', 'Latte','Soia'], category: "Gunkan",image: gunfusio },
  { id: 169, name: 'Gunkan Avocado', description: 'Philadelphia, avocado e salsa zafferano', price: 5.00, allergens: ['Pesce', 'Latte'], category: "Gunkan",image: gunavo },

  
 
  
  { id: 179, name: 'Chirashi Shake', description: 'Chirashi salmone, sesamo, salsa teriyaki', price: 9.00, allergens: ['Pesce', 'Sesamo', 'Soia'] , category: "Chirashi",image: chirasha},
  { id: 180, name: 'Chirashi Misto', description: 'Chirashi Pesce misto, sesamo, salsa teriyaki', price: 9.00, allergens: ['Pesce', 'Sesamo', 'Soia'] , category: "Chirashi",image: chiramis},
  
  
  { id: 184, name: 'Frutti di Mare Assortiti', description: 'Calamari, surimi, granchio, verdure, olio', price: 8.00, allergens: ['Crostacei', 'Molluschi'] , category: "Antipasti",image: frutmarass},
  { id: 186, name: 'Wakame', description: 'Wakame', price: 4.00, allergens: ['Sesamo'] , category: "Antipasti",image: wak},
  { id: 187, name: 'Edamame', description: 'Fagioli di soia', price: 4.00, allergens: ['Soia'] , category: "Antipasti",image: edama},
  { id: 188, name: 'Pane Bianco 2pz', description: 'Pane cinese al vapore', price: 3.00, allergens: ['Glutine','Latte'] , category: "Antipasti",image: panbianc},
  { id: 189, name: 'Pane Coniglio 2pz', description: 'Pane coniglio dolce', price: 3.50, allergens: ['Glutine','Latte','Uova'] , category: "Antipasti",image: pancon},
  { id: 190, name: 'Ravioli Vapore 4pz', description: 'Farina, carne maiale', price: 5.00, allergens: ['Glutine'] , category: "Antipasti",image: ravvap},
  { id: 191, name: 'Shaomai 4pz', description: 'Farina, carne maiale, uova, Pesce', price: 5.00, allergens: ['Glutine','Pesce','Uova'], category: "Antipasti" ,image: shaomai},
  { id: 192, name: 'Ravioli Verdure 4pz', description: 'Farina, verdure miste', price: 5.00, allergens: ['Glutine'], category: "Antipasti",image: ravverd },
  { id: 193, name: 'Ravioli Gamberi 4pz', description: 'Farina, gamberi', price: 6.00, allergens: ['Glutine', 'Crostacei'], category: "Antipasti",image: ravgamb},
  { id: 194, name: 'Ravioli Piastra 4pz', description: 'Farina, carne maiale, alla piastra', price: 5.00, allergens: ['Glutine'], category: "Antipasti" ,image: ravpiast},
  
  
  { id: 197, name: 'Nuvole di Gamberi', description: 'Nuvole di gamberi', price: 3.00, allergens: ['Glutine', 'Crostacei'] , category: "Fritto" ,image: nuvgamb},
  { id: 198, name: 'Involtini Primavera', description: 'Verdure, pasta gialla', price: 4.00, allergens: ['Glutine'] , category: "Fritto" ,image: invprim},
  { id: 199, name: 'Involtini Gambero', description: 'Mazzacolli', price: 6.00, allergens: ['Glutine', 'Crostacei'] , category: "Fritto" ,image: invgam},
  { id: 200, name: 'Shrimps Potato 3pz', description: 'Patate, gambero', price: 6.00, allergens: ['Glutine', 'Crostacei'], category: "Fritto" ,image: shrpot},
  { id: 201, name: 'Patatine', description: 'Patatine fritte', price: 4.00, allergens: ['Glutine'] , category: "Fritto" ,image: patat},
  { id: 203, name: 'Patate Smile', description: 'Patate a forma di sorriso', price: 3.50, allergens: ['Glutine'] , category: "Fritto" ,image: patsmil},
  { id: 204, name: 'Pollo Cotoletta', description: 'Pollo impanato', price: 5.00, allergens: ['Glutine'] , category: "Fritto" ,image: pollcoto},
  { id: 205, name: 'Chele di Granchio', description: 'Farina, uova, chele di granchio', price: 4.50, allergens: ['Glutine', 'Crostacei'] , category: "Fritto" ,image: chelgran},
  { id: 206, name: 'Polpetta Takoyaki', description: 'Polpa di takoyaki, maionese, salsa teriyaki, katsuobushi', price: 5.00, allergens: ['Glutine', 'Molluschi','Uova','Pesce','Soia'] , category: "Fritto" ,image: polptako},
  { id: 208, name: 'Ebi Tempura 3pz', description: 'Gamberi in tempura', price: 6.00, allergens: ['Glutine', 'Crostacei'], category: "Fritto" ,image: ebitem},
  { id: 209, name: 'Tempura Mariawase', description: 'Tempura mista di gambero e verdure', price: 9.00, allergens: ['Glutine', 'Crostacei'], category: "Fritto"  ,image: tempmari},
  { id: 210, name: 'Ebi Tempura Special', description: 'Gambero fritto e prezzemolo', price: 6.00, allergens: ['Glutine', 'Crostacei'], category: "Fritto"  ,image: ebitemspe},
  { id: 211, name: 'Ebi Pan Special', description: 'Gambero fritto con crosta di pane', price: 6.00, allergens: ['Glutine', 'Crostacei'], category: "Fritto"  ,image: ebipanspe},

  
  { id: 212, name: 'Zuppa Miso', description: 'Miso, tofu, alghe, cipollina verde', price: 3.00, allergens: ['Soia'] , category: "Zuppa" ,image: zupmis},
  { id: 213, name: 'Zuppa Agropiccante', description: 'Pollo, verdure miste, uova, piccante', price: 4.00, allergens: ['Uova','Soia'] , category: "Zuppa" ,image: zupagro},
  { id: 215, name: 'Zuppa di Pollo e Mais', description: 'Zuppa di pollo e mais, uova', price: 4.00, allergens: ['Uova'] , category: "Zuppa" ,image: zuppolmai},
  
  
  { id: 218, name: 'Riso Cantonese', description: 'Riso saltato con uova, piselli, prosciutto cotto', price: 6.00, allergens: ['Uova','Soia'] , category: "Primi" ,image: riscan},
  { id: 219, name: 'Riso Gambero', description: 'Riso saltato, uova, verdure miste, gambero', price: 7.00, allergens: ['Crostacei', 'Uova','Soia'] , category: "Primi" ,image: risgam},
  { id: 220, name: 'Riso Curry', description: 'Riso saltato al curry con uova, pollo, verdure', price: 6.00, allergens: ['Uova','Soia'] , category: "Primi" ,image: riscur},
  { id: 221, name: 'Riso Speciale', description: 'Riso saltato con mais, piselli, peperoni, uova', price: 6.00, allergens: ['Uova','Soia'], category: "Primi"  ,image: risspec},
  { id: 223, name: 'Gyuniku Ramen', description: 'Spaghetti ramen e verdure miste, uova, manzo', price: 7.00, allergens: ['Uova', 'Glutine','Soia'], category: "Primi"  ,image: gyuram},
  { id: 224, name: 'Spaghetti Verdure', description: 'Spaghetti con verdure, uova, verdure miste', price: 6.00, allergens: ['Uova', 'Glutine','Soia'], category: "Primi"  ,image: spaverd},
  { id: 225, name: 'Spaghetti Gamberi', description: 'Spaghetti con verdure miste, uova, gamberi', price: 7.00, allergens: ['Uova', 'Glutine','Soia','Crostacei'] , category: "Primi" ,image: spagamb},
  { id: 226, name: 'Spaghetti Riso Verdure', description: 'Spaghetti di riso saltati con verdure, uova', price: 6.00, allergens: ['Uova', 'Glutine','Soia'], category: "Primi"  ,image: sparisver},
  { id: 227, name: 'Spaghetti Riso Gamberi', description: 'Spaghetti di riso saltati, verdure, uova, gamberi', price: 7.00, allergens: ['Uova', 'Glutine','Soia','Crostacei'] , category: "Primi" ,image: sparisgamb},
  { id: 228, name: 'Spaghetti Soia Verdure', description: 'Spaghetti di soia saltati con verdure', price: 6.00, allergens: ['Glutine','Soia'] , category: "Primi" ,image: spasoverd},
  { id: 229, name: 'Spaghetti Soia Gamberi', description: 'Spaghetti di soia saltati con frutti di mare e verdure', price: 7.00, allergens: ['Glutine','Soia','Crostacei','Molluschi'] , category: "Primi" ,image: spasogamb},
  { id: 230, name: 'Spaghetti Soia Carne', description: 'Carne di maiale, cipolla, peperoni piccanti, soia', price: 6.50, allergens: ['Glutine','Soia'] , category: "Primi" ,image: spasocar},
  { id: 231, name: 'Spaghetti Yaki Udon', description: 'Spaghetti yaki udon saltati con frutti di mare, verdure miste, funghi', price: 7.00, allergens: ['Uova','Glutine','Soia','Crostacei','Molluschi'] , category: "Primi" ,image: spayaud},
  { id: 233, name: 'Spaghetti Ramen Saltato', description: 'Spaghetti ramen saltati con frutti di mare, verdure miste, uova, funghi', price: 7.00, allergens: ['Uova','Glutine','Soia','Crostacei','Molluschi'] , category: "Primi" ,image: sparamsal},
  { id: 234, name: 'Spaghetti Riso Curry', description: 'Spaghetti di riso al curry saltati con verdure miste, pollo, uova', price: 6.00, allergens: ['Uova','Glutine','Soia'] , category: "Primi" ,image: spariscur},
  { id: 235, name: 'Spaghetti Pad Thai', description: 'Spaghetti tagliatelle di riso saltati con frutti di mare, uova, verdure, arachidi', price: 8.00, allergens:['Uova','Glutine','Soia','Crostacei','Molluschi','Arachidi'], category: "Primi"  ,image: spapadthai},
  { id: 236, name: 'Spaghetti Ragu', description: 'Carne macinato con funghi', price: 8.00, allergens:['Glutine'], category: "Primi"  ,image: spagragu},
  { id: 237, name: 'Spaghetti Scoglio', description: 'Cozze, vongole, gamberi e calamari', price: 8.00, allergens:['Glutine','Crostacei','Molluschi'], category: "Primi"  ,image: spagscog},

  
  { id: 240, name: 'Pollo Limone', description: 'Pollo al limone', price: 6.00, allergens: [] , category: "Secondi",image: pollimo},
  { id: 241, name: 'Pollo Funghi e Bambu', description: 'Pollo con funghi e bambu', price: 6.00, allergens: [] , category: "Secondi",image: polfunbam},
  { id: 243, name: 'Pollo Curry', description: 'Pollo con verdure al curry', price: 6.00, allergens: [], category: "Secondi" ,image: polcury},
  { id: 244, name: 'Pollo Mandorle', description: 'Pollo con mandorle e verdure', price: 6.00, allergens: ['Noci'], category: "Secondi" ,image: polmand},
  { id: 245, name: 'Pollo Kungpao', description: 'Pollo con arachidi, zucchine, carote', price: 6.00, allergens: ['Arachidi'], category: "Secondi",image:  polkung},
  { id: 247, name: 'Maiale Agrodolce', description: 'Maiale fritto con peperoni, ananas e salsa agrodolce', price: 6.50, allergens: ['Glutine'], category: "Secondi" ,image: maialagro},
  { id: 248, name: 'Manzo con Patate', description: 'Manzo saltato con patate', price: 7.00, allergens: ['Glutine'], category: "Secondi",image: manzpat },
  { id: 249, name: 'Manzo con Peperoni', description: 'Manzo saltato con peperoni', price: 7.00, allergens: [], category: "Secondi" ,image: manzpep},
  { id: 250, name: 'Manzo Funghi e Bambu', description: 'Manzo saltato con funghi e bambu', price: 7.00, allergens: [] , category: "Secondi",image: manfungbamb},
  { id: 251, name: 'Anatra Arrosto Aromi', description: 'Anatra arrosto agli aromi', price: 8.00, allergens: ['Glutine'], category: "Secondi",image: anaarar },
  { id: 252, name: 'Anatra all\'Arancia', description: 'Anatra con arancia', price: 8.00, allergens: ['Glutine'] , category: "Secondi",image: anaaranc},
  { id: 254, name: 'Gamberi Salsa Agrodolce', description: 'Gamberi con peperoni, ananas e salsa agrodolce', price: 7.00, allergens: ['Crostacei'], category: "Secondi",image: gambsalagro },
  { id: 255, name: 'Gamberi Funghi e Bambu', description: 'Gamberi con funghi e bambu', price: 7.00, allergens: ['Crostacei'] , category: "Secondi",image: gambfunbamb},
  { id: 256, name: 'Gamberi Piccante', description: 'Gamberi con peperoncino e peperoni', price: 9.00, allergens: ['Crostacei'], category: "Secondi" ,image: gambpicc},
  { id: 257, name: 'Gamberi Sale Pepe', description: 'Gamberi con sale e pepe, peperoni e cipolla', price: 7.00, allergens: ['Crostacei'], category: "Secondi",image: gambsalpep },
  { id: 258, name: 'Crem Chicken', description: 'Cosca di pollo gambero e funghi', price: 8.00, allergens: ['Crostacei'], category: "Secondi",image: cremchick },

  { id: 260, name: 'Padella Frutti di Mare', description: 'Frutti di mare con funghi, bambu, cipolla e salsa piccante', price: 10.00, allergens: ['Crostacei','Molluschi'], category: "Secondi",image: padfrutmar },
  { id: 261, name: 'Padella Manzo', description: 'Manzo con porri, carote, peperoni e salsa piccante', price: 10.00, allergens: [] , category: "Secondi",image: padmanz},
  { id: 262, name: 'Padella Verdure', description: 'Cavolo duro, pancetta, carote e peperoncino', price: 7.00, allergens: [], category: "Secondi",image: padverd },
  
  
  { id: 267, name: 'Spiedini Gambero 4PZ', description: 'Spiedini di gamberi', price: 8.00, allergens: ['Crostacei'] , category: "Piastra",image: spiedgam},
  { id: 268, name: 'Spiedini Pollo 4PZ', description: 'Spiedini di pollo con sesamo e teriyaki', price: 6.50, allergens: ['Sesamo','Soia'] , category: "Piastra",image: spiedpol},
  { id: 271, name: 'Scampi alla Piastra 4PZ', description: 'Scampi alla piastra', price: 10.00, allergens: ['Crostacei'], category: "Piastra" ,image: scamppias},
  { id: 272, name: 'Gamberi alla Piastra', description: 'Gamberoni alla piastra', price: 10.00, allergens: ['Crostacei'], category: "Piastra",image: gambpias },
  { id: 274, name: 'Salmone Piastra', description: 'Salmone alla piastra', price: 8.00, allergens: ['Pesce'], category: "Piastra",image: salmpias },
  { id: 275, name: 'Zucchine alla Piastra', description: 'Zucchine alla piastra', price: 5.00, allergens: [] , category: "Piastra",image: zucpias},
  { id: 276, name: 'Peperoni Misto', description: 'Peperoni misti alla piastra', price: 5.00, allergens: [] , category: "Piastra",image: pepmist},
  { id: 277, name: 'Tataki Salmone', description: 'Salmone scottato con sesamo e decorazione di rucola, salsa ponzu', price: 8.00, allergens: ['Pesce', 'Sesamo','Soia'], category: "Piastra" ,image: tatsal},


  { id: 300, name: 'Acqua Naturale', description: '50cl', price: 1.50, allergens: [] , category: "Bevande"},
  { id: 301, name: 'Acqua Frizzante', description: '50cl', price: 1.50, allergens: [] , category: "Bevande"},
  { id: 302, name: 'Bibita in Lattina', description: '33cl', price: 3.00, allergens: [] , category: "Bevande"},

  { id: 310, name: 'Asahi', description: '50cl', price: 5.50, allergens: [] , category: "Birre"},
  { id: 311, name: 'Sapporo', description: '66cl', price: 5.50, allergens: [] , category: "Birre"},
  { id: 312, name: 'Tsingtao', description: '64cl', price: 5.50, allergens: [] , category: "Birre"},

  { id: 330, name: 'Ribolla Gialla', description: 'I feudi di Romans', price: 20.00, allergens: [] , category: "Vino"},
  { id: 331, name: 'Grechetto Montefalco', description: 'Terre de la Custodia', price: 15.00, allergens: [] , category: "Vino"},
  { id: 332, name: 'Pinot Grigio Trentino', description: 'Dorigati', price: 18.00, allergens: [] , category: "Vino"},
  { id: 333, name: 'Prosecco Millesimato', description: '', price: 14.00, allergens: [] , category: "Vino"},
  { id: 334, name: 'Prosecco Extra Dry', description: '', price: 18.00, allergens: [] , category: "Vino"},
  { id: 335, name: 'Pecorino', description: '', price: 15.00, allergens: [] , category: "Vino"},
  { id: 336, name: 'Pesserina', description: '', price: 15.00, allergens: [] , category: "Vino"},
  { id: 337, name: 'Falanghina', description: '', price: 15.00, allergens: [] , category: "Vino"},
  { id: 338, name: 'Verdicchio', description: '', price: 16.00, allergens: [] , category: "Vino"},
  { id: 339, name: 'Chardonnay', description: '', price: 20.00, allergens: [] , category: "Vino"},

  { id: 350, name: 'Rubium Rosso', description: '', price: 20.00, allergens: [] , category: "Vino Rosso"},
  { id: 351, name: 'Amarone Valpolicella', description: '', price: 40.00, allergens: [] , category: "Vino Rosso"}


];

const categories = ["Tutti", "Carpaccio", "Tartare", "Nido", "Millefoglie", "Tacos", "Flowers", "Nigiri", "Sashimi", "Hosomaki", "Uramaki", "Duomila Speciale", "Maki Fritti", "Sushi Box" , "Gunkan" ,"Temaki", "Chirashi", "Antipasti", "Fritto", "Zuppa", "Primi", "Secondi", "Piastra","Bevande","Birre","Vino","Vino Rosso"];
const allergens = ["Sedano", "Uova", "Pesce", "Crostacei", "Sesamo", "Noci", "Glutine", "Diossido di zolfo", "Soia", "Arachidi", "Latte", "Lupini", "Molluschi", "Senape"];

function Menu() {
  // Stati per gestire la UI e l'input dell'utente
  const [isFloating, setIsFloating] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Tutti');
  const [selectedAllergens, setSelectedAllergens] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [showAllergens, setShowAllergens] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState('asporto');
  const [deliveryDateTime, setDeliveryDateTime] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [intercomName, setIntercomName] = useState('');
  const [minDateTime, setMinDateTime] = useState('');
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [deliveryMode] = useState(''); // Aggiunto per tenere traccia della modalità di consegna
  const [warningMessage] = useState(''); // Stato per il messaggio di avviso
  const [showDiscountAlert, setShowDiscountAlert] = useState(true);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // NEW: consenso privacy obbligatorio
const [privacyAccepted, setPrivacyAccepted] = useState(false);
// NEW: identificatore utente e versione policy
const userId = getOrCreateUserId();
// Cambia questa data ogni volta che aggiorni Privacy/Cookie Policy
const POLICY_VERSION = '2025-08-01';

  

  const handleNextSlide = () => {
    if (carouselIndex < 2) {
      setCarouselIndex(carouselIndex + 1);
    } else {
      setCarouselIndex(null); // Impostato a null per far scomparire il carosello
    }
  };
  

  // Imposta la data minima al montaggio del componente
  useEffect(() => {
    const now = new Date();
    const formattedDateTime = now.toISOString().slice(0, 16); // YYYY-MM-DDTHH:MM
    setMinDateTime(formattedDateTime);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        setIsFloating(true);
      } else {
        setIsFloating(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Pulizia dell'evento quando il componente viene smontato
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    // Funzione per prevenire lo scroll automatico durante il focus
    const handleFocus = (event) => {
      event.preventDefault(); // Previene lo scroll automatico del browser
    };

    const searchInput = document.querySelector('.search-input');
    if (searchInput) {
      searchInput.addEventListener('focus', handleFocus);
    }

    return () => {
      if (searchInput) {
        searchInput.removeEventListener('focus', handleFocus);
      }
    };
  }, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };



  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setShowCategories(false);
    setIsSidebarOpen(false); // Chiude il menu laterale dopo la selezione
  };

  const handleAllergenChange = (allergen) => {
    setSelectedAllergens((prevState) =>
      prevState.includes(allergen)
        ? prevState.filter((a) => a !== allergen)
        : [...prevState, allergen]
    );
    // Chiude il menu laterale dopo la selezione
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const toggleCategories = () => {
    setShowCategories((prevState) => !prevState);
    setShowAllergens(false);
  };

  const toggleAllergens = () => {
    setShowAllergens((prevState) => !prevState);
    setShowCategories(false);
  };

  const toggleCart = () => {
    setIsCartOpen((prevState) => !prevState);
  };

  const addToCart = (item) => {
    setCartItems((prevState) => {
      const existingItem = prevState.find(cartItem => cartItem.id === item.id);
      if (existingItem) {
        return prevState.map(cartItem =>
          cartItem.id === item.id
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      } else {
        return [...prevState, { ...item, quantity: 1 }];
      }
    });
  };

  const handleOrderSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    // NEW: impedisce l'invio se la privacy non è accettata
  if (!privacyAccepted) {
    alert("Per inviare l'ordine devi accettare la Privacy Policy e il trattamento dei dati.");
    return;
  }

    // Mostra il modale per ricordare lo sconto, solo la prima volta
    if (deliveryMethod === 'asporto' && totalCost < 30 && showDiscountAlert) {
        setShowDiscountAlert(false);
        setShowDiscountModal(true);
        return;
    }

    // Procedi direttamente con l'invio dell'ordine
    submitOrder();
};

  const submitOrder = () => {


    if (customerName.length < 4) {
      alert("Il nome deve essere lungo almeno 4 caratteri.");
      return;
    }

    if (deliveryMethod === 'domicilio') {
      if (deliveryAddress.length < 4) {
        alert("La via deve essere lunga almeno 4 caratteri.");
        return;
      }

      if (deliveryMode === 'domicilio' && totalCost < 30) {
        alert("L'ordine minimo per la consegna a domicilio è di 30€.");
        return; // Blocca l'invio dell'ordine
      }

      if (intercomName.length < 2) {
        alert("Il nome sul citofono deve essere lungo almeno 2 caratteri.");
        return;
      }
    }

    if (!deliveryDateTime) {
      alert("Seleziona una data e un'ora per la consegna.");
      return;
    }

    const selectedDateTime = new Date(deliveryDateTime);
    const now = new Date();
    
    if (selectedDateTime < now) {
      alert("La data e l'ora selezionate devono essere nel futuro.");
      return;
    }

    const selectedHours = selectedDateTime.getHours();

    // Controlla che l'orario sia compreso tra le fasce orarie aperte del ristorante
    if (
      !(
        (selectedHours >= 12 && selectedHours < 15) ||
        (selectedHours >= 19 && selectedHours < 23)
      )
    ) {
      alert("L'orario selezionato non è valido. Gli orari di apertura sono dalle 12:00 alle 15:00 e dalle 19:00 alle 23:00.");
      return;
    }

    setIsCartOpen(false);
    sendOrderToWhatsApp();
  };

  

  const sendOrderToWhatsApp = () => {
    const restaurantPhoneNumber = "393762424788"; // Sostituire con il numero del ristorante
  
    // Formattazione della data e dell'ora senza i secondi
    const selectedDateTime = new Date(deliveryDateTime);
    const formattedDateTime = selectedDateTime.toLocaleString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  
    let message = `Ciao, vorrei ordinare!\nNome: ${customerName}\nModalità: ${deliveryMethod}\nData e ora: ${formattedDateTime}\n\nOrdine:\n`;
  
    // Aggiungi i dettagli del carrello
    cartItems.forEach(item => {
      if (item.id >= 300) {
        message += `${item.name} x${item.quantity}\n`;
      } else {
        message += `${item.id} x${item.quantity}\n`;
      }
    });
  
     // Se l'utente ha scelto "A domicilio", aggiungi indirizzo, nome sul citofono e metodo di pagamento
     if (deliveryMethod === 'domicilio') {
      message += `\nIndirizzo di consegna: ${deliveryAddress}\nNome sul citofono: ${intercomName}\nMetodo di pagamento: ${paymentMethod}`;
    }

    // Codifica il messaggio per l'URL di WhatsApp
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${restaurantPhoneNumber}?text=${encodedMessage}`;

    // Apri WhatsApp con il messaggio precompilato
    window.open(whatsappUrl, '_blank');
  };

  const filteredItems = menuItems
    .filter(item =>
      item.name.toLowerCase().startsWith(searchTerm.toLowerCase())
    )
    .filter(item =>
      selectedCategory === 'Tutti' || item.category === selectedCategory
    )
    .filter(item =>
      selectedAllergens.length === 0 || !item.allergens.some(allergen => selectedAllergens.includes(allergen))
    );

  // Calcolo del costo totale e del conteggio totale degli articoli nel carrello
const totalCost = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
const totalCartCount = cartItems.reduce((acc, item) => acc + item.quantity, 0);

// Funzione per rimuovere un solo elemento dal carrello
const removeFromCart = (itemId) => {
  setCartItems((prevState) =>
    prevState
      .map((cartItem) => {
        if (cartItem.id === itemId) {
          // Riduce la quantità di 1 se l'articolo corrisponde
          return { ...cartItem, quantity: cartItem.quantity - 1 };
        }
        return cartItem;
      })
      .filter((cartItem) => cartItem.quantity > 0) // Rimuove l'articolo solo se la quantità raggiunge 0
  );
};

  return (
    <section id="menu" className="menu">

      {/* Modal per ricordare lo sconto del 20% */}
      {showDiscountModal && (
        <div className="discount-modal">
          <div className="modal-content">
          <p>Ricorda: se il tuo ordine d'asporto supera i 50€, hai diritto a uno sconto del 20%!*</p>
      <button 
        onClick={() => { 
          setShowDiscountModal(false); 
          setIsCartOpen(false); // Chiude il carrello
        }}
      >
        Continua ad ordinare
      </button>
      <button 
        onClick={() => { 
          setShowDiscountModal(false); 
          submitOrder(); // Procede con l'invio dell'ordine
        }}
      >
        Invia Ordine
      </button>
      <p className="note">* Tranne per i sushi box</p>
    </div>
  </div>
      )}

       {/* Carosello introduttivo a schermo intero */}
       {carouselIndex !== null && (
        <div className="intro-carousel">
          {[introImage1, introImage2, introImage3].map((image, index) => (
            <div
              key={index}
              className={`intro-slide ${carouselIndex === index ? 'active' : ''}`}
            >
              <img src={image} alt={`Benvenuto ${index + 1}`} className="intro-image" />
              <p className="intro-text">
                {index === 0 && 'Benvenuto da Duomila - Ascoli Piceno !'}
                {index === 1 && 'Scegli tra le varietà di piatti per soddisfare il tuo palato.'}
                {index === 2 && 'Ordina facilmente e goditi la nostra cucina direttamente a casa tua!'}
              </p>
            </div>
          ))}
          <button className="intro-next-btn" onClick={handleNextSlide}>
            Avanti
          </button>
        </div>
      )}
    {carouselIndex === null && (
        <>
      <div className="logo-container">
        <img src={logoImage} alt="Logo del Ristorante" className="logo" />
      </div>

      <button
        className="sidebar-toggle-btn"
        onClick={toggleSidebar}
      >
        {isSidebarOpen ? <FaTimes /> : "Menu"}
      </button>

      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <button className="sidebar-section-btn" onClick={toggleCategories}>
          Categorie
        </button>
        {showCategories && (
          <div className="sidebar-list">
            {categories.map((category) => (
              <div
                key={category}
                className={`sidebar-item ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => handleCategoryChange(category)}
              >
                {category}
              </div>
            ))}
          </div>
        )}

        <button className="sidebar-section-btn" onClick={toggleAllergens}>
          Allergeni
        </button>
        {showAllergens && (
          <div className="sidebar-list">
            {allergens.map((allergen) => (
              <div
                key={allergen}
                className={`sidebar-item ${selectedAllergens.includes(allergen) ? 'active' : ''}`}
                onClick={() => handleAllergenChange(allergen)}
              >
                {allergen}
              </div>
            ))}
          </div>
        )}

        {/* Pulsanti per Policy */}
              <button
                className="sidebar-section-btn"
                onClick={() => window.open('/privacy-policy', '_blank')}
              >
                Privacy Policy
              </button>
              <button
                className="sidebar-section-btn"
                onClick={() => window.open('/cookie-policy', '_blank')}
              >
                Cookie Policy
              </button>
      </div>

     {/* Barra di ricerca integrata direttamente nel menu */}
     <div className={`search-bar ${isFloating ? 'floating' : ''}`}>
        <input
          type="text"
          placeholder="Cerca un piatto..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>

        <div className="menu-items row">
          {filteredItems.length > 0 ? (
            filteredItems.map((item) => (
              <div key={item.id} className="menu-item col-md-4">
                {item.image && (
          <img src={item.image} alt={item.name} className="menu-image" />
        )}
                <div className="menu-details">
                  <h3 className="menu-name">{item.name}</h3>
                  <p className="category-label">{item.category}</p>
                  <p className="menu-description">{item.description}</p>
                  <span className="menu-price">&euro;{item.price}</span>
                  <button className="add-to-cart-btn" onClick={() => addToCart(item)}>
                    <FaCartPlus />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <p className="no-results">Nessun piatto trovato</p>
          )}
        </div>
      

      {/* Pulsante del carrello */}
      <button className="cart-button" onClick={toggleCart}>
        <FaShoppingCart />
        <span className="cart-count">{totalCartCount}</span>
      </button>

     {/* Vista del carrello */}
     {isCartOpen && (
        <div className="cart">
          <div className="cart-header">
            <h3>Carrello</h3>
            <button className="close-cart-circle-btn" onClick={toggleCart}>
            <FaTimes />
          </button>
          </div>
          {cartItems.length > 0 ? (
            <>
              <ul>
          {cartItems.map((item, index) => (
            <li key={index} className="cart-item">
              {item.quantity}x {item.name} - &euro;{item.price * item.quantity}
              <button
                className="remove-from-cart-btn"
                onClick={() => removeFromCart(item.id)}
              >
                <FaTrashAlt />
              </button>
            </li>
          ))}
        </ul>
              <p className="total-cost">Totale: &euro;{totalCost}</p>
              <form onSubmit={handleOrderSubmit} className="order-form">
                <label htmlFor="customer-name">Nome:</label>
                <input
                  type="text"
                  id="customer-name"
                  placeholder="Inserisci il tuo nome"
                  value={customerName}
                  onChange={(e) => setCustomerName(e.target.value)}
                  required
                />
                <label htmlFor="delivery-datetime">Data e Ora:</label>
                <input
                  type="datetime-local"
                  id="delivery-datetime"
                  value={deliveryDateTime}
                  onChange={(e) => setDeliveryDateTime(e.target.value)}
                  min={minDateTime}
                  required
                />
                <div className="delivery-method">
                  <p className="delivery-method-title">Modalità di consegna:</p>
                  <label>
                    <input
                      type="radio"
                      name="deliveryMethod"
                      value="asporto"
                      checked={deliveryMethod === 'asporto'}
                      onChange={(e) => setDeliveryMethod(e.target.value)}
                    />
                    D'asporto
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="deliveryMethod"
                      value="domicilio"
                      checked={deliveryMethod === 'domicilio'}
                      onChange={(e) => setDeliveryMethod(e.target.value)}
                    />
                    A domicilio
                  </label>
                </div>
                {/* Messaggio di avviso */}
      {warningMessage && <p className="warning-message">{warningMessage}</p>}

                {deliveryMethod === 'domicilio' && (
    <>
      {totalCost < 30 && (
        <p className="warning-message">
          Per fare un ordine a domicilio, il totale deve superare i 30€.
        </p>
      )}
      <label htmlFor="delivery-address">Via:</label>
      <input
        type="text"
        id="delivery-address"
        placeholder="Inserisci la via"
        value={deliveryAddress}
        onChange={(e) => setDeliveryAddress(e.target.value)}
        required
        disabled={totalCost < 30}
      />
      <label htmlFor="intercom-name">Nome sul Citofono:</label>
      <input
        type="text"
        id="intercom-name"
        placeholder="Inserisci il nome sul citofono"
        value={intercomName}
        onChange={(e) => setIntercomName(e.target.value)}
        required
        disabled={totalCost < 30}
      />
      <p className="payment-title">Metodo di pagamento:</p>
      <div className="payment-method">
        <label>
          <input
            type="radio"
            name="payment"
            value="POS"
            checked={paymentMethod === 'POS'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            required
            disabled={totalCost < 30}
          />
          <span>POS</span>
        </label>
        <label>
          <input
            type="radio"
            name="payment"
            value="Contanti"
            checked={paymentMethod === 'Contanti'}
            onChange={(e) => setPaymentMethod(e.target.value)}
            required
            disabled={totalCost < 30}
          />
          <span>Contanti</span>
        </label>
      </div>
    </>
  )}

  {/* NEW: Consenso privacy obbligatorio */}
<div className="privacy-consent">
  <label htmlFor="privacy-consent" className="privacy-label">

    <input
      type="checkbox"
      id="privacy-consent"
      checked={privacyAccepted}
      onChange={(e) => {
    const checked = e.target.checked;
    setPrivacyAccepted(checked);

    // NEW: log immediato del consenso/rifiuto privacy per l'ordine
    logConsent({
      type: 'order_privacy',
      action: checked ? 'accepted' : 'rejected',
      policyVersion: POLICY_VERSION,
      userId,
      pagePath: window.location.pathname,
    });
  }}
  required
/>
    <span>
      Ho letto e accetto la{" "}
      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      {" "}e il trattamento dei dati <strong>*</strong>
    </span>
  </label>
  <small className="privacy-note">* Obbligatorio per l'uso del servizio</small>
</div>

                <button
  type="submit"
  className="submit-order-btn"
  disabled={(deliveryMethod === 'domicilio' && totalCost < 30) || !privacyAccepted} // NEW: || !privacyAccepted
>
  Invia Ordine
</button>

              </form>
            </>
          ) : (
            <p>Il carrello è vuoto</p>
          )}
        </div>
          )}
        </>
      )}

      
    </section>
  );
}




export default Menu;